import axios from 'axios'

async function getDeliveryDates(configurationCode, quoteId, stockCarId, stockOrder) {
  const params = {
    configurationCode: configurationCode,
    quoteId: quoteId,
    stockCarId: stockCarId,
    stockOrder: stockOrder,
  }

  try {
    const response = await axios.get('getDeliveryDates', { params })
    return response.data
  } catch (e) {
    if (e.response.status == 404) {
      return null
    }

    return Promise.reject(e)
  }
}

export default {
  async GetDeliveryDatesByConfigurationCode(configurationCode, stockOrder) {
    const result = await getDeliveryDates(configurationCode, null, null, stockOrder)
    return result
  },

  async GetDeliveryDatesByQuoteId(quoteId) {
    const result = await getDeliveryDates(null, quoteId, null)
    return result
  },

  async GetDeliveryDatesByStockCarId(stockCarId) {
    const result = await getDeliveryDates(null, null, stockCarId)
    return result
  },
}
